import type {
  BlockDefinition,
  GroupElement,
  SeatMapData,
  SeatMapElement,
  SectionElement
} from '@peekops/peek-extensions-framework/fe-apps/seat-map-renderer/types/seat-map'

export interface SeatBlockMatch {
  block: BlockDefinition
  group: GroupElement
}

function isSection(element: SeatMapElement): element is SectionElement {
  return Array.isArray((element as SectionElement).groups)
}

export function getAllSeatBlocks(mapData: SeatMapData): BlockDefinition[] {
  return mapData.sections.filter(isSection).flatMap((section) => section.groups.flatMap((group) => group.blocks))
}

// copies the map instead of mutating it, since the same mapData is shared with the step
export function withAssignedBlocks(mapData: SeatMapData, blockIds: string[]): SeatMapData {
  return {
    ...mapData,
    sections: mapData.sections.map((element) => {
      if (!isSection(element)) return element

      return {
        ...element,
        groups: element.groups.map((group) => ({
          ...group,
          blocks: group.blocks.map((block) =>
            blockIds.includes(block.id) ? { ...block, assigned: true } : block
          )
        }))
      }
    })
  }
}

export function findSeatBlock(mapData: SeatMapData, blockId: string): SeatBlockMatch | undefined {
  for (const section of mapData.sections.filter(isSection)) {
    for (const group of section.groups) {
      const block = group.blocks.find((candidate) => candidate.id === blockId)

      if (block) return { block, group }
    }
  }

  return undefined
}
